import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { getTranslation } from "../translations/getTranslations";

const HostPreview = ({ isMobile, html, name, onClose }) => {
  const language = useSelector(state => state.settings.language);
  const selectedGateway = useSelector(state => state.gateways.selectedGateway);
  const translation = key => getTranslation("hostPreview", key, language);

  return (
    <div className={`flex h-full flex-col bg-[#fff6f1] p-5 text-lg`}>
      <div className="mb-4 flex items-center justify-between">
        <button
          onClick={onClose}
          className={`flex h-[35px] w-[200px] items-center justify-center rounded bg-buttonSubmit px-2 py-1 text-buttonText hover:bg-buttonSubmitHover`}
        >
          <FontAwesomeIcon icon={faAngleLeft} className="mr-2" />
          {isMobile ? translation("_backToDevices").slice(0, 4) : translation("_backToDevices")}
        </button>

        <div className={`text-center font-bold text-[#3b3748]`}>
          {name} ({selectedGateway.name})
        </div>
        <div className={`text-center font-semibold italic text-[#3b3748]`}>{name}</div>
      </div>

      <div className="flex-grow">
        <iframe
          title="host-preview"
          srcDoc={html}
          width="100%"
          height="100%"
          className={`rounded border border-inputBorder focus:outline-none`}
        ></iframe>
      </div>
    </div>
  );
};

export default HostPreview;
